import { useIdentityStore } from '@/stores/identity'
import type { Auth } from '../http/auth'

export class TokenAuth implements Auth {
  async authenticate(
    reqInit: RequestInit,
    url: string,
    serviceName: string,
    reauthenticate?: boolean,
  ): Promise<void> {
    if (reqInit.headers) {
      const identity = useIdentityStore()
      const token = identity.auth?.access?.token
      ;(reqInit.headers as Record<string, string>)['authorization'] =
        `Bearer ${token}`
    }
  }
}
